import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { getUserDetails, logout } from "../actions/userActions";
import Blackbackground from "./Blackbackground";
import TaskType from "./TaskType";
import { taskJson } from "../models/taskModel";
import { createInvoiceTask } from "../actions/taskActions";
import { INVOICE_TASK_CREATE_RESET } from "../constants/taskConstants";

function Header(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [userdt, setUserdt] = useState({});
  const [nav, setNav] = useState(false);
  const [openTask, setOpenTask] = useState(false);
  const [taskInput, setTaskInput] = useState(taskJson);

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo, expdt } = userLogin;

  const userDetails = useSelector((state) => state.userDetails);
  const { loading, user, error } = userDetails;

  const {
    loadingCreate,
    errorCreate,
    success: successCreate,
  } = useSelector((s) => s.taskCreate);

  const handleLogout = () => {
    dispatch(logout());
  };

  const handleCancel = (e) => {
    setTaskInput({ ...taskJson });
    setOpenTask(false);
  };

  const handleChange = (e) => {
    setTaskInput({ ...taskInput, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(createInvoiceTask(taskInput));
  };

  useEffect(() => {
    if (userInfo === null || userInfo === undefined || userInfo === "") {
      navigate("/logout");
    } else {
      var dt = new Date();
      if (expdt < dt.getTime()) {
        navigate("/logout");
      }

      if (user == undefined || user.length == 0) {
        dispatch(getUserDetails());
      } else {
        setUserdt(user.Result[0]);
      }
    }
    if (successCreate) {
      setTimeout(() => {
        dispatch({ type: INVOICE_TASK_CREATE_RESET });
        setTaskInput({ ...taskJson });
        setOpenTask(false);
      }, 2500);
    }
  }, [dispatch, userInfo, user, successCreate]);

  return (
    <>
      <Blackbackground nav={nav} setNav={setNav} />

      <nav className="navbar">
        <div className="dekstop-view">
          <div className="top-bar">
            <div className="user float-right dropdown">
              <ul className="nav navbar-nav ml-auto">
                <li className="nav-item">
                  <a href="dashboard.html" className="nav-link">
                    <i className="fas fa-home"></i>
                  </a>
                </li>
                <li className="nav-item">
                  <a href="settings.html" className="nav-link">
                    {" "}
                    <i className="fa fa-cog"></i>
                  </a>
                </li>
                <li className="nav-item">
                  <a href="#" className="nav-link">
                    <i className="fas fa-search"></i>
                  </a>
                </li>
                <li className="nav-item dropdown">
                  <a
                    href="#"
                    className="nav-link dropdown-toggle"
                    data-toggle="dropdown"
                  >
                    {userdt.Name}
                    <img
                      src="/assets/img/user.jpg"
                      className="dropdown-toggle rounded-circle"
                      alt="user"
                    />
                  </a>
                  <div className="dropdown-menu dropdown-menu-right">
                    <a href="/account" className="dropdown-item">
                      <i className="fa fa-user-circle" aria-hidden="true"></i>{" "}
                      Account
                    </a>
                    <a href="/change-password" className="dropdown-item">
                      <i className="fa fa-key" aria-hidden="true"></i> Change
                      Password
                    </a>
                    <div className="dropdown-divider"></div>
                    <a className="dropdown-item" onClick={handleLogout}>
                      <i className="fas fa-sign-out-alt"></i> Logout
                    </a>
                  </div>
                </li>
              </ul>
            </div>
            <div className="top-left-bar float-left">
              <button
                className="openNav ml-5"
                type="button"
                data-toggle="canvas"
                data-target="#bs-canvas-left"
                aria-expanded="false"
                aria-controls="bs-canvas-left"
                onClick={(e) => setNav(!nav)}
              >
                &#9776;
              </button>
            </div>
            <div className="top-left-bar">
              <h2 className="home-title" style={{ fontSize: "27px" }}>
                {props.pageName ? <>{props.pageName}</> : <></>}
              </h2>
            </div>
          </div>
        </div>

        <div className="mobile-view">
          <div className="top-bar">
            <div className="user float-right dropdown">
              <ul className="nav navbar-nav ml-auto">
                <li className="nav-item">
                  <a href="#" className="nav-link">
                    <i className="fas fa-search"></i>
                  </a>
                </li>

                <li className="nav-item show-user-view">
                  <a href="#" className="nav-link">
                    {" "}
                    <i className="fa fa-ellipsis-h" aria-hidden="true"></i>
                  </a>
                </li>
              </ul>
            </div>
            <div className="brand-se">
              <a href="dashboard.html">
                <img
                  src="/assets/img/logo-icon.png"
                  className="img-icon"
                  alt="Search Education"
                />
              </a>
            </div>
            <div className="top-left-bar float-left">
              <button
                className=" openNav ml-5"
                type="button"
                data-toggle="canvas"
                data-target="#bs-canvas-left"
                aria-expanded="false"
                aria-controls="bs-canvas-left"
              >
                &#9776;
              </button>
            </div>
          </div>

          <div className="user-mob-view user">
            <div className="user-mob-view-left">
              <ul className="nav navbar-nav">
                <li className="nav-item dropdown">
                  <a
                    href="dashboard.html"
                    className="nav-link dropdown-toggle"
                    data-toggle="dropdown"
                  >
                    {" "}
                    <img
                      src="/assets/img/user.jpg"
                      className="dropdown-toggle rounded-circle"
                      alt="user"
                    />
                  </a>
                  <div className="dropdown-menu dropdown-menu-right">
                    <a href="#" className="dropdown-item">
                      <i className="fa fa-user-circle" aria-hidden="true"></i>{" "}
                      Account
                    </a>
                    <a href="#" className="dropdown-item">
                      <i className="fa fa-key" aria-hidden="true"></i> Change
                      Password
                    </a>
                    <div className="dropdown-divider"></div>
                    <a href="#" className="dropdown-item">
                      <i className="fas fa-sign-out-alt"></i> Logout
                    </a>
                  </div>
                </li>
              </ul>
            </div>
            <div className="user-mob-view-right">
              <ul className="nav navbar-nav">
                <li className="nav-item">
                  <a href="dashboard.html" className="nav-link">
                    <i className="fas fa-home"></i>
                  </a>
                </li>
                <li className="nav-item">
                  <a href="settings.html" className="nav-link">
                    {" "}
                    <i className="fa fa-cog"></i>
                  </a>
                </li>
                <li className="nav-item">
                  <a href="#" className="nav-link">
                    <i className="fas fa-search"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </nav>

      <div
        id="bs-canvas-left"
        className={`bs-canvas bs-canvas-anim bs-canvas-left position-fixed bg-light h-100 ${
          nav ? "showNav" : ""
        }`}
      >
        <header className="bs-canvas-header brand-se-web p-2 pt-3">
          <h4 className="d-inline-block text-light mb-0">
            <Link to="/">
              <img
                src="/assets/img/logo-icon.png"
                className="img-icon"
                alt="Search Education"
              />
              <b>
                Search
                <br /> Education{" "}
              </b>
            </Link>
          </h4>
          <button
            type="button"
            className="bs-canvas-close close"
            aria-label="Close"
          >
            <span aria-hidden="true" className="text-light">
              &times;
            </span>
          </button>
        </header>
        <div className="bs-canvas-content nav-img-icon">
          <ul className="list-unstyled">
            <li>
              <Link to="/" title="Dashboard">
                <img
                  src="/assets/img/contact-icon.png"
                  className="img-icon"
                  alt="Dashboard"
                />
                <span>Dashboard</span>
              </Link>
            </li>
            <li>
              <Link to="/university" title="University">
                <img
                  src="/assets/img/deal-icon.png"
                  className="img-icon"
                  alt="University"
                />
                <span>University</span>
              </Link>
            </li>
            <li>
              <Link to="/affiliate-partner" title="Affiliate Partner">
                <img
                  src="/assets/img/application-icon.png"
                  className="img-icon "
                  alt="Affiliate Partner"
                />
                <span>Affiliate Partner</span>
              </Link>
            </li>
            <li>
              <Link to="/partner-agent" title="Partner Agent">
                <img
                  src="/assets/img/event-icon.png"
                  className="img-icon "
                  alt="Partner Agent"
                />
                <span>Partner Agent</span>
              </Link>
            </li>
            <li>
              <Link to="/sub-agent" title="Sub Agents">
                <img
                  src="/assets/img/Deals.svg"
                  className="img-icon "
                  alt="Sub Agent"
                />
                <span>Sub Agent</span>
              </Link>
            </li>
            <li>
              <Link to="/invoice" title="Invoice">
                <img
                  src="/assets/img/task-icon.png"
                  className="img-icon"
                  alt="Invoice"
                />
                <span>Invoices</span>
              </Link>
            </li>
            <li>
              <Link to="/task" title="Task">
                <img
                  src="/assets/img/event-icon.png"
                  className="img-icon "
                  alt="Task"
                />
                <span>Task</span>
              </Link>
            </li>
            <li>
              <Link to="/invoice/subagent" title="Sub Agent Invoice">
                <img
                  src="/assets/img/application-icon.png"
                  className="img-icon"
                  alt="Sub Agent Invoice"
                />
                <span>Sub Agent Invoice</span>
              </Link>
            </li>
            <li>
              <Link to="/document" title="Document">
                <img
                  src="/assets/img/contact-icon.png"
                  className="img-icon"
                  alt="Document"
                />
                <span>Document</span>
              </Link>
            </li>
            {/* <li>
                            <Link to="/partner-agent-invoices" title="Partner Agent Invoices">
                                <img src="/assets/img/repository-icon.png" className="img-icon" alt="Tasks" />
                                <span>Partner Agent Invoices</span>
                            </Link>
                        </li>
                        <li>
                            <Link to="/affiliate-partner-invoices" title="Affiliate Partner Invoices">
                                <img src="/assets/img/marketing-icon.png" className="img-icon px-2" alt="Marketing" />
                                <span>Affiliate Partner Invoices</span>
                            </Link>
                        </li>
                        <li>
                            <Link to="/student-invoices" title="Student Invoices">
                                <img src="/assets/img/sales-icon.png" className="img-icon" alt="Student Invoices" />
                                <span>Student Invoices</span>
                            </Link>
                        </li>
                        <li>
                            <Link to="/sub-agent-invoices" title="Sub Agent Invoices">
                                <img src="/assets/img/workflow-icon.png" className="img-icon" alt="Sub Agent Invoices" />
                                <span>Sub Agent Invoices</span>
                            </Link>
                        </li> */}
          </ul>
        </div>
      </div>

      {/* Task Section */}
      <div
        id="self-task-popup"
        className={"overlay-note-mini-max ng-scope"}
        style={
          !openTask
            ? { display: "none" }
            : { display: "block", width: "35%", right: "0px" }
        }
      >
        <div className="overlay-note-content">
          <div className="note-title">
            <h4 className="text-left text-white pl-3">Task</h4>
            <div className="closebtn">
              <a
                className=" text-right text-white"
                onClick={(e) => handleCancel()}
              >
                <i className="fas fa-times"></i>
              </a>
            </div>
          </div>

          <div className="note-body">
            <div className="log-call">
              <div className="row">
                <div className="col-md-6">
                  <span>Task Title</span>
                  <input
                    type="text"
                    name="Task_Title"
                    className="w-100 ng-pristine ng-untouched ng-valid ng-empty"
                    placeholder="Task title..."
                    value={taskInput.Task_Title}
                    onChange={(e) => handleChange(e)}
                  />
                </div>
                <div className="col-md-6">
                  <span>Priority</span>
                  <div className="form-group">
                    <select
                      className="form-control w-100 ng-pristine ng-untouched ng-valid ng-not-empty"
                      name="Priority"
                      value={taskInput.Priority}
                      onChange={(e) => handleChange(e)}
                    >
                      <option value="">--Select--</option>
                      <option value="0" >
                        None
                      </option>
                      <option value="1"> High</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  <textarea
                    className="w-100 mt-3 ng-pristine ng-untouched ng-valid ng-empty"
                    rows="5"
                    name="Task_Description"
                    placeholder="Enter your task..."
                    style={{ resize: "none", outline: "none", border: "none" }}
                    value={taskInput.Task_Description}
                    onChange={(e) => handleChange(e)}
                  ></textarea>
                </div>
              </div>

              <div className="row">
                <div className="col-md-5">
                  <span>Type</span>
                  <div className="form-group">
                    <select
                      className="form-control w-100 ng-pristine ng-untouched ng-valid ng-not-empty"
                      name="Task_Type"
                      value={taskInput.Task_Type}
                      onChange={(e) => handleChange(e)}
                    >
                      <option value="">--Select--</option>
                      <option value="Call">Call</option>
                      <option value="Email">Email</option>
                      <option value="To Do">To-do</option>
                    </select>
                  </div>
                </div>
                <div className="col-md-7">
                  <span>Invoice Id</span>
                  <div className="form-group">
                    <input
                      className="form-control w-100 ng-pristine ng-untouched ng-valid ng-not-empty"
                      name="Invoice_Id"
                      placeholder="Enter Invoice Id"
                      value={taskInput.Invoice_Id}
                      onChange={(e) => handleChange(e)}
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <span>Due Date</span>
                  <input
                    type="date"
                    className="datepicker w-100 ng-pristine ng-untouched ng-valid ng-not-empty"
                    name="Due_Date"
                    placeholder="DD/MM/YYYY"
                    value={taskInput.Due_Date}
                    onChange={(e) => handleChange(e)}
                  />
                </div>
                <div className="col-md-6">
                  <span>Time</span>
                  <select
                    name="Due_Time"
                    className="w-100 ng-pristine ng-untouched ng-valid ng-not-empty"
                    value={taskInput.Due_Time}
                    onChange={(e) => handleChange(e)}
                  >
                    <option value="">--Select--</option>
                    <TaskType />
                  </select>
                </div>
              </div>
            </div>
            <hr />
            <button
              className="btn btn-sm btn-deep-orange waves-effect waves-light"
              onClick={handleSubmit}
              disabled={loadingCreate}
            >
              {loadingCreate ? "Loading" : "Save"}
            </button>
            <span style={{ color: "green" }}>
              {successCreate ? successCreate : ""}
            </span>
          </div>
        </div>
      </div>
      <button
        className="sleftask-btn"
        title="Team Task"
        onClick={(e) => setOpenTask(true)}
      >
        <i className="fa fa-tasks" aria-hidden="true"></i>
      </button>
    </>
  );
}

export default Header;
